<div class="crop__container">
  <div class="crop-image__left">
    <div *ngIf="imageChangedEvent">
      <div class="image-popup__title">
        <h1>{{ isFront ? 'Front-Coin Display Upload/crop' : 'Back-Coin Display Upload/crop' }}</h1>
      </div>
      <div class="image-croper__bg">
        <div>
          <h3 class="image-popup__subtitle">Adjust the coin within the circle.</h3>
        </div>
        <div class="row">
          <div class="col-12">

            <div class="img-cropper">




              <ly-img-cropper style="margin: auto; background-color: transparent; width: 100%;" [config]="myConfig"
                (ready)="ready = true" (cleaned)="ready = false" [(scale)]="scale" (minScale)="minScale = $event"
                (cropped)="onCropped($event)" (loaded)="onLoaded($event)" (error)="onError($event)">
              </ly-img-cropper>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="popup-bottom">
      <h2>Drag image to position your coin within the circle</h2>
      <div class="progress-bar">
        <div class='wrapper'>
          <label for="" class="range-label d-block">Zoom:<span class="range-percent">
              <span> 
                <button class="zoom-buutons" type="button" (click)="zoomIn()" ly-button appearance="icon">
                  <ly-icon>zoom_in</ly-icon>
                </button>
                <button class="zoom-buutons" type="button" (click)="zoomOut()" ly-button appearance="icon">
                  <ly-icon>zoom_out</ly-icon>
                </button>
              </span>
            </span></label>
          <!-- <input class="custom-control__range" type="range" step="0.5" value="0" min="0" max="100" [(ngModel)]="zoomLevel" (input)="onZoomChange($event)" /> -->
          <!-- <div *ngIf="ready" [className]="classes.sliderContainer" style="width: 100% ;display: flex;">
            <ly-slider [thumbVisible]="false" [min]="minScale" [max]="1" [(ngModel)]="scale"
              (input)="onSliderInput($event)" [step]="0.000001"></ly-slider>
          </div> -->

          <div *ngIf="ready" [className]="classes.sliderContainer" style="width: 100%!important ;display: flex;">
            <ly-slider [thumbVisible]="false" [min]="minScale" [max]="maxScale" [(ngModel)]="scale"
              (input)="onSliderInput($event)" [step]="0.000001" style="width: 100%;"></ly-slider>
          </div>

        </div>
      </div>
      <div class=" popup-button">
        <div class="login-btn">
          <button type="button" (click)="cancel()" class="btn-outline">Cancel</button>
        </div>
        <div class="login-area-button login-btn">
          <button type="button" (click)="crop()" class="primary-join-btn">Crop Image</button>
        </div>
      </div>

      <div class="popup-button row" *ngIf="croppedImage">
        <div class="col-md-4">
          <div><img [class]="classes.cropResult" *ngIf="croppedImage" [src]="croppedImage"></div>
        </div>
        <div class="col-md-4">
          <div class="login-area-button login-btn">
            <button type="button" (click)="applyChanges()" class="primary-join-btn">Save</button>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="crop-image__instruction">
    <div class="instruction-container">
      <div class="instruction-content__des">
        <h2>Correct Orientation</h2>
        <p>Do: Ensure the coin’s head is pointing up. <br>
          Don't: Avoid uploading coins in a rotated position</p>
      </div>
      <div class="instruction__images">
        <div class="row">
          <div class="col-md-6 col-6">
            <div class="check text-center"><i class="far fa-check"></i></div>
            <div class="instructio-card__valid">
              <div class="bar-bg">
                <img src="assets/images/gallery/Header.png" class="img-fluid" alt="">

              </div>
              <div class="coin-upload__image">
                <img src="assets/images/gallery/coin-upload.png" class="img-fluid" alt="coin-upload">
              </div>
              <div class="border-line"></div>
              <div class="border-horizental">
                <img src="assets/images/gallery/border-horizental.png" class="img-fluid" alt="">
              </div>

            </div>
          </div>
          <div class="col-md-6 col-6">
            <div class="mark-time text-center"><i class="far fa-times"></i></div>
            <div class="instructio-card__invalid">

              <div class="bar-bg">
                <img src="assets/images/gallery/Header.png" class="img-fluid" alt="">

              </div>
              <div class="coin-upload__image">
                <img src="assets/images/gallery/coin-upload-invalid.png" class="img-fluid mix-blend-mode"
                  alt="coin-upload">
              </div>
              <div class="border-line"></div>
              <div class="border-horizental">
                <img src="assets/images/gallery/border-horizental.png" class="img-fluid" alt="">
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="instruction-container">
      <div class="instruction-content__des">
        <h2>Proper Positioning</h2>
        <p>Do: Center your coin within the overlay circle. <br>
          Don't: Don't let the edges of your coin go beyond the crop line.</p>
      </div>
      <div class="instruction__images">
        <div class="row">
          <div class="col-md-6 col-6">
            <div class="check text-center"><i class="far fa-check"></i></div>
            <div class="instructio-card__valid">
              <div class="bar-bg">
                <img src="assets/images/gallery/Header.png" class="img-fluid" alt="">

              </div>
              <div class="coin-upload__image">
                <img src="assets/images/gallery/coin-upload.png" class="img-fluid" alt="coin-upload">
              </div>

              <div class="border-line"></div>
              <div class="border-horizental">
                <img src="assets/images/gallery/border-horizental.png" class="img-fluid" alt="">
              </div>

            </div>
          </div>
          <div class="col-md-6 col-6">
            <div class="mark-time text-center"><i class="far fa-times"></i></div>
            <div class="instructio-card__invalid">

              <div class="bar-bg">
                <img src="assets/images/gallery/Header.png" class="img-fluid" alt="">

              </div>
              <div class="card-img-bg">
                <div class="card-img">
                  <div class="coins-img">
                    <img src="assets/images/gallery/coin__img.png" alt="coin__img">
                  </div>
                </div>
              </div>
              <div class="border-line"></div>
              <div class="border-horizental">
                <img src="assets/images/gallery/border-horizental.png" class="img-fluid" alt="">
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="instruction-container">
      <div class="instruction-content__des">
        <h2>Optimal Zoom</h2>
        <p>Do: Zoom in to fill the circle with the coin, showing as much detail as possible. <br>
          Don't: Avoid images where the coin is too small or not zoomed in sufficiently.</p>
      </div>
      <div class="instruction__images">
        <div class="row">
          <div class="col-md-6 col-6">
            <div class="check text-center"><i class="far fa-check"></i></div>
            <div class="instructio-card__valid">
              <div class="bar-bg">
                <img src="assets/images/gallery/Header.png" class="img-fluid" alt="">

              </div>
              <div class="coin-upload__image">
                <img src="assets/images/gallery/coin-upload.png" class="img-fluid" alt="coin-upload">
              </div>
              <div class="border-line"></div>
              <div class="border-horizental">
                <img src="assets/images/gallery/border-horizental.png" class="img-fluid" alt="">
              </div>

            </div>
          </div>
          <div class="col-md-6 col-6">
            <div class="mark-time text-center"><i class="far fa-times"></i></div>
            <div class="instructio-card__invalid">

              <div class="bar-bg">
                <img src="assets/images/gallery/Header.png" class="img-fluid" alt="">

              </div>

              <div class="card-img-bg">
                <div class="card-img">
                  <img class="w-img" src="assets/images/gallery/coin__img.png" alt="coin__img">
                </div>
              </div>
              <div class="border-line"></div>
              <div class="border-horizental">
                <img src="assets/images/gallery/border-horizental.png" class="img-fluid" alt="">
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>